import { RemittanceChannel } from '@dill/dill-shared';
import {
  Check,
  Bank,
  EnvelopeSimple,
  ArrowsLeftRight,
  CurrencyCircleDollar,
  Upload,
} from 'phosphor-react';

const channelConfig: Record<
  RemittanceChannel,
  { label: string; icon: React.ReactNode; className: string }
> = {
  CHECK_UPLOAD: {
    label: 'Check',
    icon: <Check size={12} weight="bold" />,
    className: 'bg-violet-50 text-violet-700 ring-violet-600/20',
  },
  LOCKBOX: {
    label: 'Lockbox',
    icon: <Bank size={12} weight="bold" />,
    className: 'bg-blue-50 text-blue-700 ring-blue-600/20',
  },
  ACH: {
    label: 'ACH',
    icon: <ArrowsLeftRight size={12} weight="bold" />,
    className: 'bg-cyan-50 text-cyan-700 ring-cyan-600/20',
  },
  WIRE: {
    label: 'Wire',
    icon: <CurrencyCircleDollar size={12} weight="bold" />,
    className: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  },
  EMAIL: {
    label: 'Email',
    icon: <EnvelopeSimple size={12} weight="bold" />,
    className: 'bg-orange-50 text-orange-700 ring-orange-600/20',
  },
  MANUAL: {
    label: 'Manual',
    icon: <Upload size={12} weight="bold" />,
    className: 'bg-gray-50 text-gray-700 ring-gray-600/20',
  },
};

interface ChannelBadgeProps {
  channel: RemittanceChannel;
}

export const ChannelBadge = ({ channel }: ChannelBadgeProps) => {
  const config = channelConfig[channel];
  return (
    <span
      className={
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ring-1 ring-inset ' +
        config.className
      }>
      {config.icon}
      {config.label}
    </span>
  );
};
